module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/1-ls-c24a7d4a60c8b330406970b887cdc05e.webp";